import { useMutation } from '@tanstack/react-query';

const postForm = async (formData) => {
  console.log('Sending AWS voucher form submission:', formData);
  const response = await fetch('/api/send-voucher', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(formData),
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const data = await response.json();
  return { status: response.status, data };
};

const useWebFormAwsVoucher = ({ setPageStep }) => {
  const mutation = useMutation({
    mutationFn: postForm,
    onSuccess({ status }) {
      if (status === 200) {
        setPageStep('success');
      } else {
        setPageStep('fatalError');
        console.error('There was an error processing your request. Please try again later, or contact us');
      }
    },
    onError() {
      setPageStep('fatalError');
    },
  });

  return {
    send(data) {
      mutation.mutate(data);
    },
    isLoading: mutation.isPending,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
  };
};

export default useWebFormAwsVoucher;
